export default "__VITE_ASSET__DEjfOjVd__"